export default "__VITE_ASSET__B0sUXg$i__"